import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { catchError, from, Observable, switchMap, throwError } from 'rxjs';
import { JwtHelperService } from '@auth0/angular-jwt';
import { AuthenticationService } from '../authentication/authentication.service';
import { InactivityService } from '../services/inactivity.service';
import { TokenService } from '../services/token.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {

  constructor(private jwtHelper: JwtHelperService, private authService: AuthenticationService, private inactivityService: InactivityService, private tokenService: TokenService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let token = localStorage.getItem('access_token');

    request = this.addToken(request, token);

    return next.handle(request).pipe(
      catchError((err: HttpErrorResponse) => {
        if (err.status === 401 && token && this.jwtHelper.isTokenExpired(token)) {

          return this.handleExpiredToken(request, next);
        }

        return throwError(() => err)
      }
    ));
  }

  private handleExpiredToken(request: HttpRequest<any>, next: HttpHandler) {
    return from(this.tokenService.getValidAccessToken()).pipe(
      switchMap((token) => {
        this.inactivityService.resetTimer();
        return next.handle(this.addToken(request, token));
      }),
      catchError((err) => {
        this.authService.logout();
        return throwError(() => err);
      }),
    );
  }

  private addToken(request: HttpRequest<any>, token: string | null) {
    return request.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });
  }
}
